'use strict'

import Axios from 'axios'
import { parseResponse, handleError } from '@/_helpers/utils.js'

export default {
  store (models) {
    return new Promise((resolve, reject) => {
      Axios.post('/1.0/calls', {calls: models})
        .then(response => {
          resolve(parseResponse(response).data)
        })
        .catch(err => reject(handleError(err)))
    })
  }
}
